export function buildEmAbertoFilterOptions({
  selectedColumnFilters,
  citiesWithCounts = [],
  bairrosWithCounts = [],
  clientesWithCounts = [],
  tiposOSWithCounts = [],
  slasWithCounts = [],
  equipamentosWithCounts = [],
  statusWithCounts = [],
  tecnicoInicialWithCounts = [],
  defeitoDescricaoWithCounts = [],
  defeitoAlertWithCounts = [],
  defeitoClassificationWithCounts = [],
  defeitoSeverityWithCounts = [],
}) {
  const defeitoSubmenuSelectionsCount =
    selectedColumnFilters.defeitoDescricao.length +
    selectedColumnFilters.defeitoAlert.length +
    selectedColumnFilters.defeitoClassification.length +
    selectedColumnFilters.defeitoSeverity.length;

  const filterOptions = [
    {
      key: 'clearAll',
      label: 'Limpar filtros',
      icon: 'arrow-counterclockwise',
      count: 0,
      description: 'Resetar todos os filtros da coluna',
      isClearAction: true,
    },
    {
      key: 'retorno',
      label: 'Retorno',
      icon: 'arrow-return-left',
      count: selectedColumnFilters.retorno === 'sim' || selectedColumnFilters.retorno === 'nao' ? 1 : 0,
      description: 'Sim ou Não',
    },
    {
      key: 'cidade',
      label: 'UF e cidade',
      icon: 'geo-alt',
      count: selectedColumnFilters.cidade.length,
      description: `Filtrar por UF e localização (${citiesWithCounts.length} disponíveis)`,
    },
    {
      key: 'bairro',
      label: 'Bairro',
      icon: 'map',
      count: selectedColumnFilters.bairro.length,
      description: `Filtrar por bairro (${bairrosWithCounts.length} disponíveis)`,
    },
    {
      key: 'cliente',
      label: 'Cliente',
      icon: 'person',
      count: selectedColumnFilters.cliente.length,
      description: `Filtrar por cliente (${clientesWithCounts.length} disponíveis)`,
    },
    {
      key: 'tipoOS',
      label: 'Tipo de OS',
      icon: 'wrench',
      count: selectedColumnFilters.tipoOS.length,
      description: `Filtrar por tipo de OS (${tiposOSWithCounts.length} disponíveis)`,
    },
    {
      key: 'sla',
      label: 'SLA',
      icon: 'stopwatch',
      count: selectedColumnFilters.sla.length,
      description: `Filtrar por SLA (${slasWithCounts.length} disponíveis)`,
    },
    {
      key: 'equipamento',
      label: 'Equipamento',
      icon: 'printer',
      count: selectedColumnFilters.equipamento.length,
      description: `Filtrar por equipamento (${equipamentosWithCounts.length} disponíveis)`,
    },
    {
      key: 'status',
      label: 'Status',
      icon: 'signpost-split',
      count: selectedColumnFilters.status.length,
      description: `Filtrar por status (${statusWithCounts.length} disponíveis)`,
    },
    {
      key: 'tecnicoInicial',
      label: 'Técnico inicial',
      icon: 'person-badge',
      count: (selectedColumnFilters.tecnicoInicial && selectedColumnFilters.tecnicoInicial.length) || 0,
      description: `Filtrar por técnico inicial (${tecnicoInicialWithCounts.length} disponíveis)`,
    },
    {
      key: 'defeitoSubmenu',
      label: 'Defeitos',
      icon: 'bug',
      count: defeitoSubmenuSelectionsCount,
      description: 'Filtrar por descrição, alerta, classificação e criticidade',
      openSubmenu: true,
    },
  ];

  const defeitoSubOptions = [
    {
      key: 'defeitoDescricao',
      label: 'Defeito',
      icon: 'card-text',
      count: selectedColumnFilters.defeitoDescricao.length,
      description: `Descrição do defeito (${defeitoDescricaoWithCounts.length} disponíveis)`,
    },
    {
      key: 'defeitoAlert',
      label: 'Código de alerta',
      icon: 'hash',
      count: selectedColumnFilters.defeitoAlert.length,
      description: `Código de alerta (${defeitoAlertWithCounts.length} disponíveis)`,
    },
    {
      key: 'defeitoClassification',
      label: 'Classificação',
      icon: 'tags',
      count: selectedColumnFilters.defeitoClassification.length,
      description: `Classificação (${defeitoClassificationWithCounts.length} disponíveis)`,
    },
    {
      key: 'defeitoSeverity',
      label: 'Criticidade',
      icon: 'speedometer2',
      count: selectedColumnFilters.defeitoSeverity.length,
      description: `Criticidade (${defeitoSeverityWithCounts.length} disponíveis)`,
    },
  ];

  return { filterOptions, defeitoSubOptions };
}
